import React, { useState, useEffect, useRef, useContext } from "react";
import { DEFAULT_BLUE, NO_STRINGIFY } from "../constants/general-constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { functions } from "../constants/common-functions";
import { useHistory } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { store } from "../context/store";
import Header from "../components/Header";
import LeftMenu from "../components/LeftMenu";

export default function UploadFile() {

  const globalState = useContext(store);

  const [buildings, setBuildings] = useState([]);
  const [floors, setFloors] = useState([]);
  const [directories, setDirectories] = useState([]);
  const [revisions, setRevisions] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);

  const [isLoaded, setIsLoaded] = useState(false);

  const [selectedBuildingId, setSelectedBuildingId] = useState(-100);
  const [selectedFloorId, setSelectedFloorId] = useState(-100);
  const [selectedDirectoryId, setSelectedDirectoryId] = useState(-100);
  const [selectedDocumentTypeId, setSelectedDocumentTypeId] = useState(-100);
  const [selectedRevisionId, setSelectedRevisionId] = useState(-100);

  const [isModel, setIsModel] = useState(0);

  const [standardDisplay, setStandardDisplay] = useState("flex");
  const [submitDisplay, setSubmitDisplay] = useState("none");
  const [successDisplay, setSuccessDisplay] = useState("none");
  const [failureDisplay, setFailureDisplay] = useState("none");

  const history = useHistory();
  const refFile = useRef(null);
  const refDescription = useRef(null);

  /* =========================
     Load data
     ========================= */

  useEffect(() => {
    if (!isLoaded) {
      loadBuildings();
      loadDirectories();
	  loadRevisions();
	  loadDocumentTypes();
      setIsLoaded(true);
    }
  }, []);
  

  useEffect(() => {
    if (selectedBuildingId !== -100) {
      loadFloors();
    }
  }, [selectedBuildingId]);

  const loadBuildings = () => {
    functions.getObjectFromAjax(
      "/resolutionsoftwareplatform/facilities",
      setBuildings,
      null
    );
  };

  const loadDirectories = () => {
    functions.getObjectFromAjax(
      "/resolutionsoftwareplatform/getallresourcedirectories",
      setDirectories,
      null
    );
  };
  
  const loadRevisions = () => {
     functions.getObjectFromAjax(
       "/resolutionsoftwareplatform/resourcerevisions",
       setRevisions,
       null
     );
   };
  
  const loadDocumentTypes = () => {
     functions.getObjectFromAjax(
       "/resolutionsoftwareplatform/administration/list/documenttypes?like=",
       setDocumentTypes,
       null
     );
   };
   

  const loadFloors = () => {
    functions.getObjectFromAjax(
      "/resolutionsoftwareplatform/facilitygetfloors?facilityId=" + selectedBuildingId,
      setFloors,
      null
    );
  };
  

  /* =========================
     Actions
     ========================= */

  const handleSubmit = () => {
    setStandardDisplay("none");
    setSubmitDisplay("flex");

    let formData = new FormData();
    formData.append("facilityId", selectedBuildingId);
    formData.append("floorId", selectedFloorId);
    formData.append("directoryId", selectedDirectoryId);
	formData.append("revisionId", selectedRevisionId);
	formData.append("documentTypeId", selectedDocumentTypeId);
    formData.append("isModel", isModel);
	formData.append("description", refDescription.current.value);
    formData.append("file", refFile.current.files[0]);

    functions.submitAjax(
      "/resolutionsoftwareplatform/uploadresource",
      formData,
      handleSuccess,
      NO_STRINGIFY,
      handleSubmitError
    );
  };

  const handleSuccess = () => {
    setTimeout(() => {
      setSubmitDisplay("none");
      setSuccessDisplay("flex");
	  resetForm();
      setTimeout(() => {
        setSuccessDisplay("none");
        setStandardDisplay("flex");
		
      }, 1000);
    }, 3000);
  };

  const handleSubmitError = () => {
    setTimeout(() => {
      setSubmitDisplay("none");
      setFailureDisplay("flex");
      setTimeout(() => {
        setFailureDisplay("none");
        setStandardDisplay("flex");
      }, 1000);
    }, 3000);
  };

  const goHome = () => {
    history.push("/home");
  };

  /* =========================
     Styles
     ========================= */

  const thisContainer = {
    display: "flex",
    position: "fixed",
    flexDirection: "column",
    width: "100%",
    height: "100vh",
    left: "0px",
    top: "0px"
  };

  const mainContainer = {
    display: "flex",
    position: "fixed",
    top: "60px",
    left: "60px",
    bottom: "0px",
    right: "0px",
    flexDirection: "column",
    overflow: "auto"
  };

  const uploadPanel = {
    display: "flex",
    width: "1000px",
    flexDirection: "column",
    margin: "100px auto 0",
    paddingBottom: "30px",
    borderRadius: "8px",
    background: "linear-gradient(135deg, #1f1f1f 0%, #2a2a2a 40%, #1a1a1a 100%)",
    border: "1px solid rgba(0,160,255,0.4)",
    boxShadow: "0 20px 50px rgba(0,0,0,0.6)"
  };

  const uploadRow = {
    display: "flex",
    height: "60px",
    alignItems: "center"
  };

  const label = {
    width: "300px",
    color: "white",
    fontSize: "20px",
    paddingLeft: "25px"
  };

  const inputPanel = {
    display: "flex",
    flexGrow: 1,
    marginRight: "20px",
    alignItems: "center"
  };

  const thisSelect = {
    flexGrow: 1,
    height: "42px",
    paddingLeft: "12px",
    fontSize: "15px",
    color: "white",
    background: "linear-gradient(180deg, #2a2a2a 0%, #1b1b1b 100%)",
    border: "1px solid rgba(255,255,255,0.3)",
    borderRadius: "6px",
    outline: "none",
    cursor: "pointer"
  };
  
  const thisOption = {
    color: "black",
    backgroundColor: "white"
  };

  const bigBlueButton = {
    width: "160px",
    height: "42px",
    backgroundColor: DEFAULT_BLUE,
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "18px",
    cursor: "pointer"
  };

  const footerButtons = {
    display: "flex",
    justifyContent: "flex-end",
    gap: "15px",
    padding: "20px 30px 0"
  };

  const processPanel = {
    display: "flex",
    width: "1000px",
    height: "400px",
    margin: "100px auto",
    borderRadius: "8px",
    background: "linear-gradient(135deg, #1f1f1f 0%, #2a2a2a 100%)",
    border: "1px solid rgba(0,160,255,0.4)",
    alignItems: "center",
    justifyContent: "center",
    color: "white"
  };
  
  const thisTextArea = {
     flexGrow: 1,
     height: "92px",
     paddingLeft: "12px",
     fontSize: "15px",
     color: "white",
     background: "linear-gradient(180deg, #2a2a2a 0%, #1b1b1b 100%)",
     border: "1px solid rgba(255,255,255,0.3)",
     borderRadius: "6px",
     outline: "none",
     cursor: "pointer"
   };
   
   
   const resetForm = () => {

     // Reset selects
     setSelectedBuildingId(-100);
     setSelectedFloorId(-100);
     setSelectedDirectoryId(-100);
     setSelectedDocumentTypeId(-100);

     // Reset model toggle
     setIsModel(0);

     // Clear dependent data
     setFloors([]);

     // Clear file input
     if (refFile.current) {
       refFile.current.value = null;
     }

     // Clear description
     if (refDescription.current) {
       refDescription.current.value = "";
     }
   };


  /* =========================
     Render
     ========================= */

  return (
    <div style={thisContainer}>
      <Header />
      <LeftMenu />

      <div style={mainContainer}>

        {/* ================= Upload Panel ================= */}
        <div style={{ ...uploadPanel, display: standardDisplay }}>

          {/* File */}
          <div style={uploadRow}>
            <div style={label}>Select a file to upload</div>
            <div style={inputPanel}>
              <input type="file" ref={refFile} style={{color:'white'}}/>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                color: "white",
                paddingRight: "25px",
                cursor: "pointer"
              }}
              onClick={() => setIsModel(isModel === 0 ? 1 : 0)}
            >
              <div
                style={{
                  width: "18px",
                  height: "18px",
                  borderRadius: "4px",
                  border: "1px solid " + DEFAULT_BLUE,
                  backgroundColor: isModel ? DEFAULT_BLUE : "transparent"
                }}
              />
              Upload to ACC (Autodesk)
            </div>
          </div>

          {/* Building */}
          <div style={uploadRow}>
            <div style={label}>Building / Facility</div>
            <div style={inputPanel}>
              <select style={thisSelect} onChange={e => setSelectedBuildingId(e.target.value)}>
                <option style={thisOption} value="-100">Select</option>
                {buildings.map(b => (
                  <option style={thisOption} key={b.id} value={b.id}>{b.name}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Floor */}
          <div style={uploadRow}>
            <div style={label}>Floor</div>
            <div style={inputPanel}>
              <select style={thisSelect} onChange={e => setSelectedFloorId(e.target.value)}>
                <option style={thisOption} value="-100">Select</option>
                {floors.map(f => (
                  <option style={thisOption} key={f.id} value={f.id}>{f.name}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Directory */}
          <div style={uploadRow}>
            <div style={label}>Directory</div>
            <div style={inputPanel}>
              <select style={thisSelect} onChange={e => setSelectedDirectoryId(e.target.value)}>
                <option style={thisOption} value="-100">Select</option>
                {directories.map(d => (
                  <option style={thisOption} key={d.id} value={d.id}>{d.name}</option>
                ))}
              </select>
            </div>
          </div>
		  
		  {/* Directory */}
           <div style={uploadRow}>
             <div style={label}>Revision</div>
             <div style={inputPanel}>
               <select style={thisSelect} onChange={e => setSelectedRevisionId(e.target.value)}>
                 <option style={thisOption} value="-100">Select</option>
                 {revisions.map(d => (
                   <option style={thisOption} key={d.id} value={d.id}>{d.name}</option>
                 ))}
               </select>
             </div>
           </div>
		  
		  {/* Document Types */}
          <div style={uploadRow}>
            <div style={label}>Document Type</div>
            <div style={inputPanel}>
              <select style={thisSelect} onChange={e => setSelectedDocumentTypeId(e.target.value)}>
                <option style={thisOption} value="-100">Select</option>
                {documentTypes.map(d => (
                  <option style={thisOption} key={d.id} value={d.id}>{d.name}</option>
                ))}
              </select>
            </div>
          </div>
		  
		  {/* Document Types */}
           <div style={{...uploadRow, alignItems:'top', height:'120px', color:'white'}}>
             <div style={label}>Description</div>
             <div style={inputPanel}>
               <textarea ref={refDescription} style={thisTextArea}/>
             </div>
           </div>

          {/* Footer Buttons */}
          <div style={footerButtons}>
            <div style={bigBlueButton} onClick={handleSubmit}>Upload</div>
            <div
              style={{ ...bigBlueButton, backgroundColor: "transparent", border: "1px solid rgba(255,255,255,0.4)" }}
              onClick={goHome}
            >
              Cancel
            </div>
          </div>

        </div>

        {/* ================= States ================= */}
        <div style={{ ...processPanel, display: submitDisplay }}>
          <CircularProgress color="inherit" />
        </div>

        <div style={{ ...processPanel, display: successDisplay }}>
          <FontAwesomeIcon icon="check" size="4x" />
        </div>

        <div style={{ ...processPanel, display: failureDisplay }}>
          <FontAwesomeIcon icon="exclamation-triangle" size="4x" />
        </div>

      </div>
    </div>
  );
}
